/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSessionRequestData } from '../models/CreateSessionRequestData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SessionService {
  /**
   * Create Session Internal
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static createSessionInternal(requestBody: CreateSessionRequestData): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/session/internal',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Session
   * @returns any Successful Response
   * @throws ApiError
   */
  public static createSession(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/session',
    });
  }
}
